import React from "react";
import { Check } from "lucide-react";

const enrollmentCards = [
  {
    id: "fit-your-life",
    title: "Make the Plan Fit Your Life",
    body: "I start with your doctors, prescriptions, budget, and coverage needs — then look for options that fit your real situation.",
  },
  {
    id: "know-choosing",
    title: "Know What You're Choosing",
    body: "I explain the details and tradeoffs in plain language, so you understand what matters before you enroll.",
  },
  {
    id: "understood-first",
    title: "Be Understood First",
    body: "Before I recommend anything, I take time to understand your health needs, your timing, your budget, and what you need your coverage to help with.",
  },
  {
    id: "know-who-to-call",
    title: "Know Who to Call After You Enroll",
    body: "Questions, claims, plan changes, and coverage reviews do not stop after signup. I'm here year-round when you need help.",
  },
  {
    id: "help-within-reach",
    title: "Keep Help Within Reach",
    body: "Whether you're in North Carolina, relocate, or need help for family elsewhere, you can keep working with someone who already understands your situation.",
  },
];

const EnrollmentCard = ({ card }) => (
  <div
    data-testid={`enrollment-card-${card.id}`}
    className="bg-white rounded-xl p-8 lg:p-10 shadow-sm hover:shadow-md transition-shadow duration-300"
  >
    <div className="w-12 h-12 bg-[#E8F5E9] rounded-full flex items-center justify-center mb-6">
      <Check size={22} className="text-[#1B2A1B]" strokeWidth={3} />
    </div>
    <h3 className="text-lg font-bold text-[#1B2A1B] mb-4">{card.title}</h3>
    <p className="text-[#5A6B5A] leading-relaxed">{card.body}</p>
  </div>
);

const WhyDifferent = () => {
  return (
    <section className="py-20 lg:py-28 bg-[#FDF4F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-14">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            Why Clients Work With Me
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1B2A1B] mt-4 mb-5 leading-tight"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Enrollment Without Second-Guessing
          </h2>
          <p className="text-[#5A6B5A] leading-relaxed text-lg max-w-2xl">
            I believe you should be understood before you're advised — and
            supported after you enroll.
          </p>
        </div>

        {/* Grid: 3 cards on top, 2 cards centered on bottom (lg) */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {enrollmentCards.map((card) => (
            <EnrollmentCard key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;
